import { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase-config";

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");

    try {
      await addDoc(collection(db, "messages"), {
        ...formData,
        timestamp: serverTimestamp(),
      });
      setStatus("success");
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      console.error("Error sending message:", error);
      setStatus("error");
    }
  };

  return (
    <main>
      <div className="line-top line-bottom text-small">
        <div className="main-inner">
          <form onSubmit={handleSubmit} className="max-w-md mx-auto">
            <div className="mb-4">
              <label htmlFor="name" className="block mb-2">
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full p-2 border rounded"
              />
            </div>

            <div className="mb-4">
              <label htmlFor="email" className="block mb-2">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full p-2 border rounded"
              />
            </div>

            <div className="mb-4">
              <label htmlFor="message" className="block mb-2">
                Message
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="4"
                className="w-full p-2 border rounded"
              />
            </div>

            <button
              type="submit"
              className="cta"
              disabled={
                status === "sending" ||
                !formData.name ||
                !formData.email ||
                !formData.message
              }
            >
              {status === "sending" ? "Sending..." : "Send Message"}
            </button>

            {status === "success" && (
              <p
                className="text-center"
                style={{
                  color: "#002FA7",
                  fontSize: "1.2rem",
                  marginTop: "2.0rem",
                  marginBottom: "1.0rem",
                }}
              >
                Message sent successfully!
              </p>
            )}
            {status === "error" && (
              <p
                className="text-center"
                style={{
                  color: "#002FA7",
                  fontSize: "1.2rem",
                  marginTop: "2.0rem",
                  marginBottom: "1.0rem",
                }}
              >
                Error sending message. Please try again.
              </p>
            )}
          </form>
        </div>
      </div>
    </main>
  );
}
